import { useEffect, useMemo } from "react";

// Utils
import { currencyFormatter } from "../../utils/Utils";

// Material-ui imports
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export function ShipmentOptionsShippingServiceSelect({
  shipment,
  setShipment,
  services,
}) {
  const shippingOptions = useMemo(() => {
    if (!services || services.length === 0) return [];
    return services;
  }, [services]);

  const updateShipment = (index) => {
    const service = shippingOptions?.[index];
    if (!service) return;
    const shippingCost = getShipmentCharge(
      service.carriageCharge,
      shipment.subtotal,
      service.carriageChargeLimit,
    );
    setShipment({
      ...shipment,
      total: Number(shipment.subtotal) + shippingCost,
      shipping: {
        index,
        agent: service.shippingAgentCode,
        service: service.code,
        cost: shippingCost,
      },
    });
  };

  const handleChange = (event) => {
    updateShipment(event.target.value);
  };

  useEffect(() => {
    if (!shippingOptions.length) return;
    const currentIndex = shipment?.shipping?.index;
    if (
      currentIndex === "" ||
      currentIndex === undefined ||
      currentIndex === null ||
      currentIndex >= shippingOptions.length
    ) {
      updateShipment(0);
    }
  }, [shippingOptions, shipment?.shipping?.index, shipment.subtotal]);

  const getShipmentCharge = (carriageCharge, subtotal, carriageChargeLimit) => {
    if (subtotal > carriageChargeLimit) return 0;
    return Number(carriageCharge);
  };

  return (
    <FormControl sx={{ m: 1, minWidth: { md: 100 } }}>
      <InputLabel id="shipping-services-select-label">
        Shipping Service
      </InputLabel>
      <Select
        labelId="shipping-services-select-label"
        id="shipping-services-select"
        value={shipment.shipping.index}
        label="Shipping Service"
        onChange={handleChange}
      >
        {/* <MenuItem value="" disabled>
          Please select..
        </MenuItem> */}
        {shippingOptions?.map((service, index) => (
          <MenuItem key={index} value={index}>
            {service.description} -{" "}
            {currencyFormatter(
              "GB",
              getShipmentCharge(
                service.carriageCharge,
                shipment.subtotal,
                service.carriageChargeLimit,
              ),
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
